import {  FaShieldAlt, FaTerminal, FaCode } from 'react-icons/fa';

const skills = [
  {
    title: 'Web Development',
    description: 'Experience using React and JavaScript to make simple websites. Made websites for hobby and also others.',
    icon: FaShieldAlt,
    type: 'Academic & Hobby Skill',
    typeIcon: <FaShieldAlt />
  },
  {
    title: 'Software Development',
    description: 'Experience using C# and Python to make simple applications.',
    icon: FaCode,
    type: 'Academic & Hobby Skill',
    typeIcon: <FaCode />
  },
  {
    title: 'Scripting',
    description: 'Experience using Python to make simple scripts.',
    icon: FaTerminal,
    type: 'Academic & Hobby Skill',
    typeIcon: <FaTerminal />
  }
];

export default skills;
